import api from '../../REST/api';
import { transformForPatch } from '../transform-opportunity-helpers';

export default async function addOpportunityFollowedByAgreement(
  changedModel,
  merchants,
) {
  const model = await transformForPatch(changedModel, {}, merchants);
  const { agreementOpportunities } = model;
  const modelWithoutAgreements = { ...model, agreementOpportunities: [] };
  const opportunity = await api.addOpportunity({
    data: modelWithoutAgreements,
  });
  if (!agreementOpportunities.length) {
    return opportunity;
  }
  const opportunityId = opportunity.id;
  return api.patchOpportunity({
    id: opportunityId,
    data: transformForPatch({ agreementOpportunities }),
  });
}
